<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: gamificationSet.breadcrumb_title,
                        href: meta.links.set_show,
                    },
                    {
                        name: $tc('messages.schedules', 1),
                        href: null,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <AlertMessage class="mt-3 inline-block" type="info">
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <template v-slot:body> {{ meta.info.gamification_schedule_explanation }} </template>
            </AlertMessage>
        </div>

        <form :action="meta.links.update" method="post" @submit.prevent="submit" class="mt-5">
            <GamificationScheduleEditor v-model="form.timeslots" :days="days" :errors="form.errors" />
            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import PanelPage from '@/Shared/PanelPage.vue';
import Layout from '@/Shared/Layout.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';
import GamificationScheduleEditor from '@/Pages/Teacher/Gamification/GamificationSets/Schedule/partials/GamificationScheduleEditor.vue';
import AlertMessage from '@/components/AlertMessage.vue';

export default {
    components: {
        AlertMessage,
        GamificationScheduleEditor,
        SubmitFormButton,
        PanelPage,
    },
    layout: Layout,
    name: 'Edit',
    props: ['meta', 'gamificationSet', 'timeslots'],
    data() {
        return {
            form: this.$inertia.form({
                timeslots: this.timeslots,
            }),
            days: [
                {
                    value: 1,
                    text: this.$t('messages.monday_single_letter'),
                },
                {
                    value: 2,
                    text: this.$t('messages.tuesday_single_letter'),
                },
                {
                    value: 3,
                    text: this.$t('messages.wednesday_single_letter'),
                },
                {
                    value: 4,
                    text: this.$t('messages.thursday_single_letter'),
                },
                {
                    value: 5,
                    text: this.$t('messages.friday_single_letter'),
                },
                {
                    value: 6,
                    text: this.$t('messages.saturday_single_letter'),
                },
                {
                    value: 0,
                    text: this.$t('messages.sunday_single_letter'),
                },
            ],
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
